"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: billing/billed-account.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbilling%2Fbilled-account.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.billedAccountStatusToJSON = exports.billedAccountStatusFromJSON = exports.BilledAccount = exports.BilledAccountStatus = void 0;
const amount_1 = require("../common/amount");
const date_1 = require("../common/date");
const auto_pay_1 = require("./auto-pay");
const protobufPackage = 'com.step.billing.proto';
var BilledAccountStatus;
(function (BilledAccountStatus) {
    BilledAccountStatus["INVALID_BILLED_ACCOUNT_STATUS"] = "INVALID_BILLED_ACCOUNT_STATUS";
    /**
     * ACCOUNT_CURRENT - All bills are paid or not due yet.
     */
    BilledAccountStatus["ACCOUNT_CURRENT"] = "ACCOUNT_CURRENT";
    /**
     * ACCOUNT_PAST_DUE - At least one bill is past the due date.
     */
    BilledAccountStatus["ACCOUNT_PAST_DUE"] = "ACCOUNT_PAST_DUE";
    /**
     * ACCOUNT_DELINQUENT - At least one bill is past the due date grace period and being reported as
     * late to credit agencies.
     */
    BilledAccountStatus["ACCOUNT_DELINQUENT"] = "ACCOUNT_DELINQUENT";
    BilledAccountStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BilledAccountStatus || (exports.BilledAccountStatus = BilledAccountStatus = {}));
function createBaseBilledAccount() {
    return {
        nextAutoPayAt: undefined,
        nextAutoPayAmount: undefined,
        autoPayFailed: false,
        autoPaySettings: auto_pay_1.AutoPay.fromPartial({}),
        availableAutoPayDays: [],
        status: BilledAccountStatus.INVALID_BILLED_ACCOUNT_STATUS,
        dueAt: undefined,
        dueOn: undefined,
        delinquentAt: undefined,
        delinquentAfter: undefined,
        closeAt: undefined,
        lateFee: amount_1.Amount.fromPartial({}),
        cyclesUntilInterestFree: 0,
    };
}
exports.BilledAccount = {
    fromJSON(object) {
        const message = {
            autoPayFailed: isSet(object.autoPayFailed) ? globalThis.Boolean(object.autoPayFailed) : false,
            autoPaySettings: isSet(object.autoPaySettings)
                ? auto_pay_1.AutoPay.fromJSON(object.autoPaySettings)
                : auto_pay_1.AutoPay.fromPartial({}),
            availableAutoPayDays: globalThis.Array.isArray(object?.availableAutoPayDays)
                ? object.availableAutoPayDays.map((e) => globalThis.Number(e))
                : [],
            status: isSet(object.status)
                ? billedAccountStatusFromJSON(object.status)
                : BilledAccountStatus.INVALID_BILLED_ACCOUNT_STATUS,
            lateFee: isSet(object.lateFee) ? amount_1.Amount.fromJSON(object.lateFee) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.nextAutoPayAt)) {
            message.nextAutoPayAt = date_1.DateMessage.fromJSON(object.nextAutoPayAt);
        }
        if (isSet(object.nextAutoPayAmount)) {
            message.nextAutoPayAmount = amount_1.Amount.fromJSON(object.nextAutoPayAmount);
        }
        if (isSet(object.dueAt)) {
            message.dueAt = date_1.ZonedDateTime.fromJSON(object.dueAt);
        }
        if (isSet(object.dueOn)) {
            message.dueOn = date_1.DateMessage.fromJSON(object.dueOn);
        }
        if (isSet(object.delinquentAt)) {
            message.delinquentAt = date_1.ZonedDateTime.fromJSON(object.delinquentAt);
        }
        if (isSet(object.delinquentAfter)) {
            message.delinquentAfter = date_1.DateMessage.fromJSON(object.delinquentAfter);
        }
        if (isSet(object.closeAt)) {
            message.closeAt = date_1.ZonedDateTime.fromJSON(object.closeAt);
        }
        if (isSet(object.cyclesUntilInterestFree)) {
            message.cyclesUntilInterestFree = globalThis.Number(object.cyclesUntilInterestFree);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nextAutoPayAt !== undefined) {
            obj.nextAutoPayAt = date_1.DateMessage.toJSON(message.nextAutoPayAt);
        }
        if (message.nextAutoPayAmount !== undefined) {
            obj.nextAutoPayAmount = amount_1.Amount.toJSON(message.nextAutoPayAmount);
        }
        if (message.autoPayFailed !== false) {
            obj.autoPayFailed = message.autoPayFailed;
        }
        if (message.autoPaySettings !== undefined) {
            obj.autoPaySettings = auto_pay_1.AutoPay.toJSON(message.autoPaySettings);
        }
        if (message.availableAutoPayDays?.length) {
            obj.availableAutoPayDays = message.availableAutoPayDays.map((e) => Math.round(e));
        }
        if (message.status !== BilledAccountStatus.INVALID_BILLED_ACCOUNT_STATUS) {
            obj.status = billedAccountStatusToJSON(message.status);
        }
        if (message.dueAt !== undefined) {
            obj.dueAt = date_1.ZonedDateTime.toJSON(message.dueAt);
        }
        if (message.dueOn !== undefined) {
            obj.dueOn = date_1.DateMessage.toJSON(message.dueOn);
        }
        if (message.delinquentAt !== undefined) {
            obj.delinquentAt = date_1.ZonedDateTime.toJSON(message.delinquentAt);
        }
        if (message.delinquentAfter !== undefined) {
            obj.delinquentAfter = date_1.DateMessage.toJSON(message.delinquentAfter);
        }
        if (message.closeAt !== undefined) {
            obj.closeAt = date_1.ZonedDateTime.toJSON(message.closeAt);
        }
        if (message.lateFee !== undefined) {
            obj.lateFee = amount_1.Amount.toJSON(message.lateFee);
        }
        if (message.cyclesUntilInterestFree !== undefined && message.cyclesUntilInterestFree !== 0) {
            obj.cyclesUntilInterestFree = Math.round(message.cyclesUntilInterestFree);
        }
        return obj;
    },
    create(base) {
        return exports.BilledAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBilledAccount();
        message.nextAutoPayAt = (object.nextAutoPayAt !== undefined && object.nextAutoPayAt !== null)
            ? date_1.DateMessage.fromPartial(object.nextAutoPayAt)
            : undefined;
        message.nextAutoPayAmount =
            (object.nextAutoPayAmount !== undefined && object.nextAutoPayAmount !== null)
                ? amount_1.Amount.fromPartial(object.nextAutoPayAmount)
                : undefined;
        message.autoPayFailed = object.autoPayFailed ?? false;
        message.autoPaySettings =
            (object.autoPaySettings !== undefined && object.autoPaySettings !== null)
                ? auto_pay_1.AutoPay.fromPartial(object.autoPaySettings)
                : auto_pay_1.AutoPay.fromPartial({});
        message.availableAutoPayDays = object.availableAutoPayDays?.map((e) => e) || [];
        message.status = object.status ?? BilledAccountStatus.INVALID_BILLED_ACCOUNT_STATUS;
        message.dueAt = (object.dueAt !== undefined && object.dueAt !== null)
            ? date_1.ZonedDateTime.fromPartial(object.dueAt)
            : undefined;
        message.dueOn = (object.dueOn !== undefined && object.dueOn !== null)
            ? date_1.DateMessage.fromPartial(object.dueOn)
            : undefined;
        message.delinquentAt = (object.delinquentAt !== undefined && object.delinquentAt !== null)
            ? date_1.ZonedDateTime.fromPartial(object.delinquentAt)
            : undefined;
        message.delinquentAfter =
            (object.delinquentAfter !== undefined && object.delinquentAfter !== null)
                ? date_1.DateMessage.fromPartial(object.delinquentAfter)
                : undefined;
        message.closeAt = (object.closeAt !== undefined && object.closeAt !== null)
            ? date_1.ZonedDateTime.fromPartial(object.closeAt)
            : undefined;
        message.lateFee = (object.lateFee !== undefined && object.lateFee !== null)
            ? amount_1.Amount.fromPartial(object.lateFee)
            : amount_1.Amount.fromPartial({});
        message.cyclesUntilInterestFree = object.cyclesUntilInterestFree ?? 0;
        return message;
    },
};
function billedAccountStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_BILLED_ACCOUNT_STATUS':
            return BilledAccountStatus.INVALID_BILLED_ACCOUNT_STATUS;
        case 1:
        case 'ACCOUNT_CURRENT':
            return BilledAccountStatus.ACCOUNT_CURRENT;
        case 2:
        case 'ACCOUNT_PAST_DUE':
            return BilledAccountStatus.ACCOUNT_PAST_DUE;
        case 3:
        case 'ACCOUNT_DELINQUENT':
            return BilledAccountStatus.ACCOUNT_DELINQUENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return BilledAccountStatus.UNRECOGNIZED;
    }
}
exports.billedAccountStatusFromJSON = billedAccountStatusFromJSON;
function billedAccountStatusToJSON(object) {
    switch (object) {
        case BilledAccountStatus.INVALID_BILLED_ACCOUNT_STATUS:
            return 'INVALID_BILLED_ACCOUNT_STATUS';
        case BilledAccountStatus.ACCOUNT_CURRENT:
            return 'ACCOUNT_CURRENT';
        case BilledAccountStatus.ACCOUNT_PAST_DUE:
            return 'ACCOUNT_PAST_DUE';
        case BilledAccountStatus.ACCOUNT_DELINQUENT:
            return 'ACCOUNT_DELINQUENT';
        case BilledAccountStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.billedAccountStatusToJSON = billedAccountStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=billed-account.js.map